// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

global.toastr = require("toastr")
require("@rails/ujs").start()
//require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')
window.jQuery = $;
window.$ = $;
require("bootstrap");
window.bootstrap = require("bootstrap");
require("admin-lte");
import "@fortawesome/fontawesome-free/js/all";
import "@fortawesome/fontawesome-free/css/all";
require("@nathanvda/cocoon")
require('datatables.net-bs4')
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
// import '@doabit/semantic-ui-sass'
require('moment')
require('moment-hijri')
require('../hijri_date/bootstrap-hijri-datepicker.js')
import Chart from 'chart.js/auto';
global.Chart = Chart;
import 'custom/custom';
import 'custom/filter';
import 'custom/loading_spinner';



document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
$(document).ready(function(){
  var url = window.location;

  // for sidebar menu entirely but not cover treeview
  $('ul.nav-sidebar a').filter(function() {
    return this.href == url;
  }).addClass('active');

  // for treeview
  $('ul.nav-treeview a').filter(function() {
    return this.href == url;
  }).parentsUntil(".nav-sidebar > .nav-treeview").addClass('menu-open').prev('a').addClass('active');


  var element = document.getElementsByTagName("table");
  for (var i = 0; i < element.length; i++) {

    var div = document.createElement("div");
    div.classList.add("table-responsive");
  //div.appendTo(element)
    element[i].parentElement.insertBefore(div, element[i]);
    div.appendChild(element[i]);
  }

  /*
  $( "select" ).each(function( index ) {
    $( this ).select2( {
      theme: "bootstrap-5",
      width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
      placeholder: $( this ).data( 'placeholder' ),
      closeOnSelect: false,
  } );
  */

  $("select").each(function( index ) {
    new TomSelect(this,{
      persist: false,
      create: false,
      copyClassesToDropdown: true
    });
  })

  $(document).on('click', '.approval-action-link', function() {
    sessionStorage.removeItem('pending_requests_count');
  });

  displaySidebarCounts();
  
});

// Register Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
  .then(function(registration) {
    return registration.pushManager.getSubscription()
      .then(function(subscription) {
        if (subscription) {
          return subscription;
        }
        return fetch('/vapid_public_key', {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          }
        }).then(function(response) {
          const contentType = response.headers.get('content-type');
          if (!contentType || !contentType.includes('application/json')) {
            throw new Error('Unexpected response, likely an HTML redirect to login.');
          }
          return response.json();
        }).then(function(vapidPublicKey) {
          // Convert the base64url-encoded public key to Uint8Array
          const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey.public_key);
          return registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedVapidKey
          });
        });
      });
  })
  .then(function(subscription) {
    fetch('/push_subscriptions', {
      method: 'POST',
      body: JSON.stringify(subscription),
      headers: {
        'Content-Type': 'application/json'
      }
    });
  })
  .catch(function(err) {
    console.error('Service Worker registration or subscription failed:', err);
  });
}


// Function to convert a base64url-encoded string to a Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

function displaySidebarCounts() {
  // display pending requests counts in sidebar
  const pendingRequestsElement = document.getElementById('pending-requests-count');
  const pendingRequestsCount = sessionStorage.getItem('pending_requests_count');
  if (!pendingRequestsCount && pendingRequestsElement) {
    fetch('/sidebar/get_pending_requests_count')
      .then(response => response.json())
      .then(data => {
        sessionStorage.setItem('pending_requests_count', data.pending_requests_count);
        if (parseInt(data.pending_requests_count) > 0) {
          pendingRequestsElement.textContent = `+ ${data.pending_requests_count}`;
        } else {
          pendingRequestsElement.remove();
        }
      });
  } else if (pendingRequestsElement) {
    if (parseInt(pendingRequestsCount) > 0) {
      pendingRequestsElement.textContent = `+ ${pendingRequestsCount}`;
    } else {
      pendingRequestsElement.remove();
    }
  }

  // display pending employees counts in sidebar
  const pendingEmployeesElement = document.getElementById('pending-employees-count');
  const pendingEmployeesCount = sessionStorage.getItem('pending_employees_count');
  if (!pendingEmployeesCount && pendingEmployeesElement) {
    fetch('/sidebar/get_pending_employees_count')
      .then(response => response.json())
      .then(data => {
        sessionStorage.setItem('pending_employees_count', data.pending_employees_count);
        if (parseInt(data.pending_employees_count) > 0) {
          pendingEmployeesElement.textContent = `+ ${data.pending_employees_count}`;
        } else {
          pendingEmployeesElement.remove();
        }
      });
  } else if (pendingEmployeesElement) {
    if (parseInt(pendingEmployeesCount) > 0) {
      pendingEmployeesElement.textContent = `+ ${pendingEmployeesCount}`;
    } else {
      pendingEmployeesElement.remove();
    }
  }

  // display employees in vacation count in sidebar
  const vacationingElement = document.getElementById('vacationing-count');
  if (!vacationingElement) {
    return;
  }
  
  const vacationingCount = sessionStorage.getItem('vacationing_count');
  if (!vacationingCount && vacationingElement) {
    fetch('/sidebar/get_vacationing_count', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        sessionStorage.setItem('vacationing_count', data.vacationing_count);
        if (parseInt(data.vacationing_count) > 0) {
          vacationingElement.textContent = `+ ${data.vacationing_count}`;
        } else {
          vacationingElement.remove();
        }
      })
      .catch(error => {
        console.error('Error fetching vacationing count:', error);
      });
  } else if (vacationingElement) {
    if (parseInt(vacationingCount) > 0) {
      vacationingElement.textContent = `+ ${vacationingCount}`;
    } else {
      vacationingElement.remove();
    }
  }
}